import { useEffect, useState } from 'react';

import { secondsUntil } from '../schemas/two-factor-rules';

/** Seconds left until `until` (ISO 8601), ticking once a second and stopping at zero. */
export function useCountdown(until: string): number {
  const [now, setNow] = useState(() => Date.now());
  const left = secondsUntil(until, now);
  const running = left > 0;

  useEffect(() => {
    if (!running) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [running]);

  return left;
}
